var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inputs" }, [
    _c(
      "div",
      { staticClass: "input input-container" },
      [
        _c("label", [_vm._v("Phone Number")]),
        _vm._v(" "),
        _c("VuePhoneNumberInput", {
          attrs: { "default-country-code": _vm.country, "no-flags": "" },
          on: { update: _vm.handlePhoneUpdate },
          model: {
            value: _vm.phoneNumber,
            callback: function ($$v) {
              _vm.phoneNumber = $$v
            },
            expression: "phoneNumber",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }